import { CURRENCY } from '@repo/shared/constants';
import { providerPreLimitValues } from './provider-pre-limit-values';
import { providerLimitValues } from './provider-limit-values';
export var getMinAvailableAmountAndCurrency = function (merchantResponseData, provider) {
    if (merchantResponseData && provider) {
        var limitValues = providerLimitValues(merchantResponseData, provider);
        if (!limitValues) {
            var preLimitValues = providerPreLimitValues(merchantResponseData, provider);
            return {
                min: (preLimitValues === null || preLimitValues === void 0 ? void 0 : preLimitValues.min) || 0,
                currency: (preLimitValues === null || preLimitValues === void 0 ? void 0 : preLimitValues.currency) || CURRENCY,
            };
        }
        return {
            min: (limitValues === null || limitValues === void 0 ? void 0 : limitValues.min) || 0,
            currency: (limitValues === null || limitValues === void 0 ? void 0 : limitValues.currency) || CURRENCY,
        };
    }
};
